import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { Copyright } from '@lon/shared/components';

const Footer: React.FC = () => (
  <Box id="footer" as="footer" aria-label="footer">
    <Flex justify="center" align="center" m="0 auto" py="15px">
      <Copyright
        gap="32px"
        direction="row"
        fontSize={{ base: '0.625rem', sm: 'xs', md: 'sm' }}
        lineHeight={{ base: 'none', sm: 'shorter', md: 'short' }}
      />
    </Flex>
  </Box>
);

export default Footer;
